import React from "react";
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "../constants/contact";
import { trackPhoneCallClick } from "../utils/conversionTracking";

const FloatingCallButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const callHref = e.currentTarget.href;

    trackPhoneCallClick({
      source: "floating-call-button",
      callback: () => {
        window.location.href = callHref;
      },
    });
  };

  return (
    <a
      className="floating-call-button"
      href={`tel:${SUPPORT_PHONE_TEL}`}
      onClick={handleClick}
      data-conversion-event="phone_call_click"
      data-call-source="floating-call-button"
      aria-label={`Call IT Assist Experts at ${SUPPORT_PHONE_DISPLAY}`}
    >
      <i className="bi bi-telephone-fill" aria-hidden="true"></i>
      <span className="floating-call-number">{SUPPORT_PHONE_DISPLAY}</span>
    </a>
  );
};

export default FloatingCallButton;
